import { NgModule } from '@angular/core';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { BlueprintSummaryComponent } from './blueprint-summary.component';
import { BleuprintSummaryRoutingModule } from './blueprint-summary-routing.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import {MatListModule} from '@angular/material/list';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DisasterRecoveryComponent } from './disaster-recovery/disaster-recovery.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { TenantInstanceComponent } from './tenant-instance/tenant-instance.component';
import { DeployInstanceModule } from '../service/deploy-instance/deploy-instance.module';
import { ReportIssueModule } from '../service/report-issue/report-issue.module';
import { ViewEndpointsModule } from '../service/view-endpoints/view-endpoints.module';
import { ViewUpdateResultsModule } from '../service/view-update-results/view-update-results.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { TenantInstanceDetailsComponent } from './tenant-instance-details/tenant-instance-details.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableModule } from 'src/app/table/table.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CustomTooltipComponent } from '../custom-tooltip/custom-tooltip.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InstanceDetailsModule } from 'src/app/components/instance-details/instance-details.module';
import {MatMenuModule} from '@angular/material/menu';
import {MatCardModule} from '@angular/material/card';
import { CapabilityCardModule } from 'src/app/components/capability-card/capability-card.module';
import { ViewCapabilityCardModule } from 'src/app/components/view-capability-card/view-capability-card.module';
import { ViewServiceDefinitionVersionDetailsModule } from 'src/app/components/view-service-definition-version-details/view-service-definition-version-details.module';
import { UpdateDefinitionModule } from './update-definition/update-definition.module';
import { ServiceDefinitionVersionModule } from './service-definition-version/service-definition-version.module';
import { VersionDetailsPopupComponent } from './version-details-popup/version-details-popup.component';
import { ResourceConfigurationModule } from './resource-configuration/resource-configuration.module';
import { UpdateResourceConfigurationModule } from './update-resource-configuration/update-resource-configuration.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSelectModule } from '@angular/material/select';
import { ErrorModule } from 'src/app/components/error/error.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { WarningDialogModule } from 'src/app/components/warning-dialog/warning-dialog.module';
import { SelectDatabaseComponent } from './select-database/select-database.component';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { CommonTableModule } from 'src/app/components/table/table.module';
import { BackupDetailsComponent } from './backup-details/backup-details.component';
import { monthYearPickerModule } from 'src/app/components/month-year-picker/month-year-picker.module';
import { TimeTakenPieModule } from 'src/app/components/time-taken-info-pie/time-taken-info-pie.module';
import { FeatureNotSupportedModule } from 'src/app/components/feature-not-supported/feature-not-supported.module';
import { EnvironmentDetailsModule } from '../environment-details/environment-details.module';
import { DeploySizingComponentModule } from './deploy-sizing/deploy-sizing.module';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { UpdateServiceDefinitionCreationModule } from '../update-service-definition-creation/update-service-definition-creation.module';
@NgModule({
  declarations: [
    BlueprintSummaryComponent,
    DisasterRecoveryComponent,
    TenantInstanceComponent,
    TenantInstanceDetailsComponent,
    CustomTooltipComponent,
    VersionDetailsPopupComponent,
    SelectDatabaseComponent,
    BackupDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatCardModule,
    IconsModule,
    BleuprintSummaryRoutingModule,
    BreadcrumbModule,
    MatListModule,
    NgxSkeletonLoaderModule,
    MatExpansionModule,
    MatDividerModule,
    DeployInstanceModule,
    ReportIssueModule,
    ViewEndpointsModule,
    ViewUpdateResultsModule,
    PipesModule,
    PageLoaderModule,
    MatTabsModule,
    MatTooltipModule,
    TableModule,
    PaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    InstanceDetailsModule,
    MatMenuModule,
    ViewServiceDefinitionVersionDetailsModule,
    ViewCapabilityCardModule,
    CapabilityCardModule,
    UpdateDefinitionModule,
    ServiceDefinitionVersionModule,
    ResourceConfigurationModule,
    UpdateResourceConfigurationModule,
    MatSlideToggleModule,
    DragDropModule,
    MatSelectModule,
    ErrorModule,
    FormsModule,
    ReactiveFormsModule,
    WarningDialogModule,
    SearchFilterModule,
    CommonTableModule,
    monthYearPickerModule,
    TimeTakenPieModule,
    FeatureNotSupportedModule,
    EnvironmentDetailsModule,
    DeploySizingComponentModule,
    UpdateServiceDefinitionCreationModule,
    UpperCasePipe,
    NgxEchartsModule.forRoot({
      echarts
    }),
  ]
})
export class BlueprintSummaryModule { }
